const Joi = require('joi')
const fields = require('../fields')

const endForgeProcessSchema = Joi.object({
    processId: fields.objectIdField,
    cancel: fields.boolField,
});

module.exports = endForgeProcessSchema;